import { IGetRewardWithCate, IReceive, IRewardCateGet } from "@interfaces";
import axiosClient from "./axiosClient";

export const rewardApi = {
    // getListReward: () => {
    //     const url = "/histories?type=REWARD";
    //     return axiosClient.get(url);
    // },
    getListReward: (params: IGetRewardWithCate) => {
        const url = "/rewards/client";
        return axiosClient.get(url, { params });
    },
    getDetailById: (id: string) => {
        const url = `/histories/${id}?type=REWARD`;
        return axiosClient.get(url);
    },
    //     redeemed:(values:IReceive)=> {
    //         const url = "/histories/redeemed";
    //        return axiosClient.post(url, values);

    //    },
    redeemed: (values: IReceive) => {
        const url = "/rewards/redeemed";
        return axiosClient.post(url, values);
    },
    getRewardCate: (params: IRewardCateGet) => {
        const url = "/reward-cat";
        return axiosClient.get(url, { params });
    },
};
